module.exports = __webpack_public_path__ + "components/intersport-discount-page/static/intersport-1600-1a326a0aa0a666aaa5c00af9c81ed60f.jpg";